import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { ChannelFormValues } from "src/models/Channel.model";
import ChannelForm from "../Layouts/ChannelForm";
import {
  useEditChannelMutation,
  useViewChannelByIdQuery,
} from "src/services/ChannelServices";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";

type Props = {
  onClose: () => void;
  channelId: string;
};

const EditChannelFormWrapper = ({ onClose, channelId }: Props) => {
  const [channelData, setChannelData] = useState<any>();
  const [editChannel] = useEditChannelMutation();
  const { data, isLoading, isFetching } = useViewChannelByIdQuery(channelId);

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setChannelData(data?.data);
    }
  }, [isFetching, isLoading, data]);

  // Form Initial Values
  const initialValues: ChannelFormValues = {
    channelName: channelData?.channelName || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    channelName: string().required("Please enter channel name"),
  });

  // Handle Submit
  const handleSubmit = (
    values: ChannelFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ChannelFormValues>
  ) => {
    setTimeout(() => {
      editChannel({
        body: values,
        id: channelId,
      }).then((res: any) => {
        if ("data" in res) {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            onClose();
            resetForm();
          } else {
            showToast("error", res?.data?.message);
          }
        } else {
          showToast("error", "Something went wrong");
        }
        setSubmitting(false);
      });
    }, 1000);
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <ChannelForm
              formType="Update"
              formikProps={formikProps}
              onClose={onClose}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditChannelFormWrapper;
